// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalSecurity = {
  securityRiskLockEnabled: "Enable risk lock",
  securityRiskLockThreshold: "Risk lock trigger threshold",
  securityRiskLockMinutes: "Risk lock duration (minutes)",
  securitySmsEnabled: "Enable SMS Verification",
  securitySmsScope: "SMS Verification Scope",
  securityOptionDisabled: "Disabled",
  securityOptionLogin: "Login Verification",
  securityOptionHighRisk: "High-Risk Actions",
  securityOptionAdminLogin: "Admin Login",
  securityCaptchaEnabled: "Enable CAPTCHA",
  securityCaptchaFailThreshold: "Consecutive Failure Threshold",
  securityIpPolicyMode: "IP Policy Mode",
  securityOptionAllowlist: "Allowlist",
  securityOptionBlocklist: "Blocklist",
  securityIpAllowlist: "IP Allowlist",
  securityIpBlocklist: "IP Blocklist",
  securitySyncHostAllowlist: "Sync Host Allowlist",
  securityLoginRateLimit: "Login Rate Limit (per minute)",
  securityVerificationRateLimit: "Verification Rate Limit (per minute)",
  securityTitle: "Security Policies",
  securitySubtitle:
    "Manage SMS verification, CAPTCHA, IP allow/block lists, rate limiting, and risk interception.",
  securityNotice:
    "Use this page to manage SMS verification, CAPTCHA, IP allow/block lists, login rate limiting, and risk interception policies.",
} as const;
